/* eslint-disable no-unused-vars */
/** @module Auth0PostLoginHandlerAndroid */
/* eslint-disable import/extensions */
import Auth0PostLoginHandlerBase from '../auth0-post-login-handler-base.mst.mjs';
import Auth0UserSessionHelper from '../../../../utils/auth0-session-helper.mjs';
import Auth0UtilsBrowser from '../../../../utils/auth0-utils-browser.mjs';
import Auth0TokenStorageHelper from '../auth0-token-storage-helper.mjs';

class Auth0PostLoginHandlerAndroid extends Auth0PostLoginHandlerBase {
  constructor(options) {
    super(options);
    this._options = options;
  }

  _shouldHandleSync = (loginData) => {
    return this._options.clientId === 'P0eAOqrACKBwhzoVKTgP76m7aYWijSYE';
  };

  /**
   * @inheritdoc
   */
  async shouldHandle(loginData) {
    return Promise.resolve(this._shouldHandleSync(loginData));
  }

  /**
   * @inheritdoc
   */
  async run(loginData) {
    // Store tokens in the default locations (legacy _lat and _latv3 cookies)
    // This ensures tokens are available for the session helper and future requests
    if (loginData.tokens) {
      Auth0TokenStorageHelper.storeTokensDefault(loginData.tokens);
    }

    // the native part of the Android app will be listening for this event that we will fire post login
    // Prefer tokens from loginData if available, fall back to session helper
    const tokens = {
      access_token: loginData.tokens?.accessToken || Auth0UserSessionHelper.userAccessToken,
      refresh_token: loginData.tokens?.refreshToken || Auth0UserSessionHelper.userRefreshToken,
      id_token: Auth0UserSessionHelper.userIdentityToken,
    };
    console.log('Auth0PostLoginHandlerAndroid: Sending tokens to Android native app', tokens);

    try {
      // This is posts a token event into a native app that has subscribed to a "authHandler" pipe.
      window.authHandler.postMessage(JSON.stringify(tokens));

      console.log('Auth0PostLoginHandlerAndroid: Sent message to Android native app; native app should hide the webview and show the native app');
    } catch (error) {
      const troubleshootingData = {
        userAgent: navigator?.userAgent,
        hasAuthHandlerProp: !!window.authHandler,
        isAndroidDevice: Auth0UtilsBrowser.isAndroidDevice,
      };
      const troubleshootingDataString = JSON.stringify(troubleshootingData, null, 2);
      console.log('Auth0PostLoginHandlerAndroid: troubleshooting data =>', troubleshootingDataString);
      document.body.innerHTML = `In an actual Android WebView, we would have fired a successful login event into the native app<p>Issue: ${error.message}<p>If this is showing in the SS app inside an Android WebView, then it is a BUG. Here is the info you need to fix it:<p><pre><code>${troubleshootingDataString}</code></pre>EVENT PAYLOAD:</p><p><code>${JSON.stringify(tokens, null, 2)}</code></p>`;
    }
  }
}

export default Auth0PostLoginHandlerAndroid;
